import { ReactComponent as IconLogo } from 'assets/images';
import { useNavigate } from 'react-router-dom';

import { SLogoWrapper, SLogoText } from './style';

export const Logo = () => {
  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate('/');
  };

  return (
    <SLogoWrapper gap={8} align="center" onClick={redirectToHome}>
      <IconLogo />
      <SLogoText align="center" justify="flex-end">
        Svitlofour
      </SLogoText>
    </SLogoWrapper>
  );
};
